var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.PromocionArt)?_c('v-card-text',{staticClass:"mt-n8 font-weight-bold"},[_c('span',{class:[
      'text-uppercase logomoneda',
      'mt-0',
      'ml-0' ]},[_vm._v(_vm._s(((_vm.Articulo[0].TipoPrecio) + " " + (_vm.simboloMoneda[_vm.tipoMoneda])))+"\n    "+_vm._s(("" + (_vm.formatMiles({
        value: _vm.PromocionArt[0]['PrecioExt-paq'] ,
        numDecimal: 2,
      }))))+"\n  ")]),_c('span',{class:['logomoneda text-uppercase']},[_vm._v("\n    "+_vm._s(_vm.PromocionArt[0].descuento  ? ("| Descuento : " + (_vm.PromocionArt[0].descuento) + " %") : null)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }